import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { OrderItemsService } from "./orderitems.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { OrderItem } from "../../api-models/OrderItem";
import { OrderItemsMainComponent } from "./orderitems.main.component";
import { saveAs } from "file-saver";
import moment from "moment";

@Component({
    selector: "app-orderitems",
    templateUrl: "./orderitems.component.html",
    styleUrls: ["orderitems.component.scss"],
    standalone: false
})
export class OrderItemsComponent extends BaseMaterialDatatableComponent<OrderItem> implements OnInit {
    public UTCDATEFORMAT: string = "";

    currentQueryParams: any = {};
    rows: OrderItem[] = [];

    startDate?: Date = undefined;
    endDate?: Date = undefined;

    dtInitialized = false;

    constructor(
        private orderItemsService: OrderItemsService,
        private translateService: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        parent: OrderItemsMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: orderItemsService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_order_items_list"
            },
            sortState: {
                active: "created",
                direction: "desc"
            },
            displayedColumns: ["user", "itemCount", "created", "actions"],
            listService: orderItemsService
        });

        this.UTCDATEFORMAT = this.orderItemsService.UTCDATEFORMAT;
    }

    override loadData() {
        this.pageState.isLoading = true;

        // get api query parameters by datatable
        const queryParams = {
            page: this.pageState.currentPage + 1,
            limit: this.pageState.pageSize,
            search: this.pageState.search,
            sort: `${this.pageState.sortState.active}|${this.pageState.sortState.direction}`,
            start: this.startDate?.toISOString(),
            end: this.endDate?.toISOString()
        };

        this.currentQueryParams = queryParams;

        const observable = this.listService.list(queryParams);

        this.subscriptions.push(
            observable.subscribe({
                next: (data) => {
                    this.dataSource.data = data.list;

                    setTimeout(() => {
                        if (this.paginator) {
                            this.paginator.pageIndex = this.pageState.currentPage;
                            this.paginator.length = data.count;
                        }
                    });
                    this.pageState.isLoading = false;
                },
                error: (error) => {
                    console.error(error);
                    this.pageState.isLoading = false;
                }
            })
        );
        return observable;
    }

    startFilterChanged(newValue: Date | undefined) {
        this.startDate = newValue;
        this.filterChanged();
    }

    endFilterChanged(newValue: Date | undefined) {
        this.endDate = newValue;
        this.filterChanged();
    }

    filterChanged() {
        this.loadData();
    }

    resetStartDate() {
        this.startDate = undefined;
    }

    resetEndDate() {
        this.endDate = undefined;
    }

    downloadOrderItemsCSV() {
        this.subscriptions.push(
            this.orderItemsService.downloadOrderItemsCSV(this.currentQueryParams).subscribe((orderItemsCSVBlob) => {
                let suffix = "";
                if (this.startDate && this.endDate) {
                    const startDate = moment(this.startDate).format("YYYY-MM-DDTHH-mm");
                    const endDate = moment(this.endDate).format("YYYY-MM-DDTHH-mm");
                    suffix = `_${startDate}_${endDate}`;
                } else {
                    if (this.startDate) {
                        const startDate = moment(this.startDate).format("YYYY-MM-DDTHH-mm");
                        suffix = `_${startDate}+`;
                    }

                    if (this.endDate) {
                        const endDate = moment(this.endDate).format("YYYY-MM-DDTHH-mm");
                        suffix = `_-${endDate}`;
                    }
                }

                const prefix = this.currentQueryParams.search ? "filtered_" : "";
                const fileName = `${prefix}orderitems${suffix}.csv`;
                saveAs(orderItemsCSVBlob, fileName);
            })
        );
    }

    viewOrder(id: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }
}
